<template>
  <div class="date-content cursor-pointer flex-col">
    <div class="top flex-b-c">
      <div class="date-select">
        <a-input-search size="large" v-model:value="keyword" placeholder="请输入日程标题" @search="onSearch"/>
      </div>
      <div class="center">
        <a-space :size="15">
          <LeftOutlined
            :style="{
              fontSize: '12px',
              padding: '10px',
              opacity: 0.6,
            }"
            @click="changeMonth('prev')"
          />
          <span class="font-w-b size14 white-s-nowrap">{{ getTitle }}</span>
          <RightOutlined
            :style="{
              fontSize: '12px',
              padding: '10px',
              opacity: 0.6,
            }"
            @click="changeMonth('next')"
          />
        </a-space>
      </div>
      <div class="right">
        <a-space :size="10">
          <div class="add txt-white" @click="showModal">新建日程</div>
          <div class="type flex wz-ba-btn">
            <span :class="'wz-br-btn ' + (type == 1 && 'active')" @click="changType(1)">月</span>
            <span :class="'wz-br-btn ' + (type == 2 && 'active')" @click="changType(2)">周</span>
            <span :class="type == 3 && 'active'" @click="changType(3)">日</span>
          </div>
          <div class="today" @click="clickToday">今天</div>
        </a-space>
      </div>
    </div>
    <div class="main margin-t15 flex-1" :class="noData && 'flex-c-c deep-bg'">
      <template v-if="!noData">
        <Month v-if="type == 1" :list="monthData" @toDetail="toDetail" @toMore="toMore"></Month>
        <Week v-if="type == 2" :list="weekData" @toMore="toMore"></Week>
        <Day
          v-if="type == 3"
          :listobj="dayData"
          @pageSizeChange="pageSizeChange"
          @pageChange="pageChange"
          @toDetail="toDetail"
          @editForm="editFormHandle"
        ></Day>
      </template>
      <div class="flex-col-c-c date-none" v-else>
        <img src="@/assets/yf-img/date-none.png" />
        <p>当前无日程安排</p>
      </div>
    </div>


    <!-- 新建日程弹框 -->
    <a-modal
      :title="title"
      width="640px"
      v-model="schedule_visible"
      :confirm-loading="false"
      :maskClosable="false"
      @ok="addSchedule"
      @cancel="resetForm"
    >
      <a-form :model="schedule_form" ref="scheduleRule" :label-col="labelCol">
        <a-form-item
          label="日程标题"
          name="scheduleName"
          :rules="[{ required: true, message: '日程标题' }]"
        >
          <a-input
            size="large"
            v-model="schedule_form.scheduleName"
            placeholder="日期标题"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item
          label="日程开始时间"
          name="startTime"
          :rules="[{ required: true, message: '请选择时间' }]"
        >
          <a-date-picker
            show-time
            size="large"
            format="YYYY-MM-DD HH:mm:ss"
            v-model="schedule_form.startTime"
            @ok="dateChange($event, 1)"
          />
        </a-form-item>
        <a-form-item
          label="日程结束时间"
          name="endTime"
          :rules="[{ required: true, message: '请选择时间' }]"
        >
          <a-date-picker
            size="large"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            @ok="dateChange($event, 2)"
            v-model="schedule_form.endTime"
          />
        </a-form-item>
        <a-form-item
          label="参与人员"
          name="partInList"
          :rules="[{ required: false, message: '选择人员' }]"
        >
          <a-select
            size="large"
            v-model="schedule_form.partInList"
            placeholder="选择人员"
            mode="multiple"
          >
            <a-select-option
              v-for="memberItem in joinList"
              :key="memberItem.id"
              :value="memberItem.id"
              >{{ memberItem.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="日程地点"
          name="sportsHallId"
          :rules="[{ required: false, message: '请选择地点' }]"
        >
          <a-select
            size="large"
            v-model="schedule_form.sportsHallId"
            placeholder="选择地点"
          >
            <a-select-option
              v-for="hallItem in hallList"
              :key="hallItem.id"
              :value="hallItem.id"
              >{{ hallItem.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="备注信息" name="remark">
          <a-textarea
            v-model="schedule_form.remark"
            placeholder="输入内容"
            :show-count="true"
            :rows="3"
            :maxlength="100"
          />
        </a-form-item>
        <a-form-item
          label="上传附件"
          :rules="[{ required: false, message: '请上传附件' }]"
          name="fileList"
        >
          <a-upload
            :file-list="schedule_form.fileList"
            name="file"
            :multiple="true"
            action="/api/file/uploadOss"
            :headers="headers"
            @change="handleChange"
            accept=".rar, .zip, .doc, .docx, .pdf"
          >
            <a-button class="upload_btn">
              <upload-outlined></upload-outlined>
              上传文件
            </a-button>
          </a-upload>
          <p class="upload_tip">
            支持格式：rar.zip.doc.docx.pdf，单个文件不能超过20MB
          </p>
        </a-form-item>
        <a-form-item
          name="syncList"
          label="同步日程人员"
          :rules="[{ required: false, message: '选择人员' }]"
        >
          <a-select
            size="large"
            v-model="schedule_form.syncList"
            placeholder="选择人员"
            mode="multiple"
          >
            <a-select-option
              v-for="memberItem in memberList"
              :key="memberItem.id"
              :value="memberItem.id"
              >{{ memberItem.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 日程详情弹框 -->
    <!-- 日程详情弹框 -->
    <a-modal
      v-model="sche_detail_visible"
      :footer="null"
      :maskClosable="false"
      :width="730"
    >
      <template #title>
        <div class="flex-b-c">
          <span>&nbsp;</span>
          <span class="head-title size18 txt-white font-w-b">日程详情</span>
          <div class="icon-img">
            <img
              src="@/assets/yf-img/edit.png"
              class="margin-r20"
              @click="editImg(schedule_detail)"
            />
            <img
              src="@/assets/yf-img/del.png"
              @click="delImg(schedule_detail.id)"
            />
          </div>
        </div>
      </template>
      <div class="modal_content">
        <div class="header">{{ schedule_detail.scheduleName }}</div>
        <div class="schedule_time_box flex-row align-center modal_item">
          <div
            class="schedule_time_item flex-column align-center"
            style="background: linear-gradient(135deg, #39cfbc 3%, #0e9fd1 95%)"
          >
            <span class="schedule_time">{{
              changeTime(schedule_detail.startTime, "HH:mm")
            }}</span>
            <span class="schedule_date"
              >{{ changeTime(schedule_detail.startTime, "MM月DD日")
              }}{{ changeTime(schedule_detail.startTime, "week") }}</span
            >
            <span class="schedule_text">开始时间</span>
          </div>
          <div
            class="schedule_time_item flex-column align-center"
            style="background: linear-gradient(135deg, #edbc6d 3%, #ea6b3a 95%)"
          >
            <span class="schedule_time">{{
              changeTime(schedule_detail.endTime, "HH:mm")
            }}</span>
            <span class="schedule_date"
              >{{ changeTime(schedule_detail.startTime, "MM月DD日")
              }}{{ changeTime(schedule_detail.startTime, "week") }}</span
            >
            <span class="schedule_text">结束时间</span>
          </div>
        </div>
        <div class="schedule_other modal_item">
          <div class="flex-row align-center">
            <span class="other_title item_header">日程地点</span>
            <span class="other_address">{{
              schedule_detail.sportsHallName
                ? schedule_detail.sportsHallName
                : "未添加地点"
            }}</span>
          </div>
        </div>
        <div
          class="join_member modal_item"
          v-if="
            schedule_detail.partInList && schedule_detail.partInList.length > 0
          "
        >
          <div class="item_header">参与人员</div>
          <div class="member_list flex-row">
            <div
              class="flex-column align-center mr-20"
              v-for="(item, index) in schedule_detail.partInList"
              :key="index"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="64" :src="item.headImageUrl" />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="schedule_other modal_item">
          <div class="flex-row align-center">
            <span class="other_title item_header">备注信息</span>
            <span class="other_address">{{
              schedule_detail.remark ? schedule_detail.remark : "未添加描述"
            }}</span>
          </div>
        </div>
        <div
          class="filelist_box mt-20 modal_item"
          v-if="
            schedule_detail.fileInfoVoList &&
            schedule_detail.fileInfoVoList.length > 0
          "
        >
          <div class="item_header">附件</div>
          <div class="filelist_list">
            <div
              class="
                filelist_item
                mb-10
                flex-row
                align-center
                justify-between
                p-10
              "
              v-for="(item, index) in schedule_detail.fileInfoVoList"
              :key="index"
            >
              <div><FileImageOutlined />{{ item.fileName }}</div>
              <div>{{ changeTime(item.createTime, "YYYY-MM-DD HH:mm:ss") }}</div>
              <div>{{ item.name }}</div>
              <div class="opera_list">
                <a-button
                  class="line-btn down_btn"
                  @click="download(item.filePath, item.fileName)"
                  >下载</a-button
                >
                <a-button
                  class="line-btn del_btn"
                  @click="delFile(item.id, index)"
                  >删除</a-button
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="join_member modal_item"
          v-if="schedule_detail.syncList && schedule_detail.syncList.length > 0"
        >
          <div class="item_header">同步日程人员</div>
          <div class="member_list flex-row">
            <div
              class="flex-column align-center mr-20"
              v-for="(item, index) in schedule_detail.syncList"
              :key="index"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="64" :src="item.headImageUrl"></a-avatar>
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import Month from "./month";
import Day from "./day";
import Week from "./week";
export default {
  inject: ["getId", "passTime", "callBack"],
  data() {
    return {
      keyword: '',
      editDateType: 1,
      title: "新建日程",
      schedule_detail: {}, //日程详情数据
      type: 1,
      noData: false,
      schedule_visible: false,
      sche_detail_visible: false,
      monthData: [],
      weekData: [],
      dayData: {
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      headers: {
        system: 0,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      schedule_file: [],
      memberList: [],
      joinList: [], // 参与人员
      schedule_form: {
        scheduleName: undefined,
        startTime: undefined,
        endTime: undefined,
        sportsHallId: undefined,
        remark: undefined,
        syncList: [],
        partInList: [],
        fileList: [],
      },
    };
  },
  components: {
    Month,
    Day,
    Week,
  },
  computed: {
    zjId() {
      return this.getId();
    },
    changeTime() {
      return function (time, type) {
        type = type ? type : "YYYY-MM-DD hh:mm:ss";
        return moment(time).format(type);
      };
    },
    getTitle() {
      if (this.type == 1) {
        return this.getDateTitle;
      } else if (this.type == 2) {
        return this.getWeekRange;
      } else {
        return `${moment(this.passTime()).format("yyyy.MM.DD")}`;
      }
    },
    // 周一和周日
    getMinMax() {
      // 获取星期
      const date = this.passTime();
      const day = date.getDay() || 7;
      const min = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - (day - 1)
      );
      const max = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + (7 - day)
      );
      return {
        min,
        max,
      };
    },
    // 周的范围
    getWeekRange() {
      const { min, max } = this.getMinMax;
      return `${moment(min).format("yyyy.MM.DD")}-${moment(max).format(
        "yyyy.MM.DD"
      )}`;
    },
    getDatePickerVal: {
      get() {
        return moment(this.passTime(), "YYYY-MM-DD");
      },
      set(e) {
        if (e) {
          // 通知父级改变时间
          this.callBack(new Date(e.format("YYYY/MM/DD HH:mm:ss")));
        } else {
          this.callBack(new Date());
        }
      },
    },
    getDateTitle() {
      let date = this.getDateFromFa;
      return `${date.getFullYear()}.${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
    },
    // 获取父级传来的时间
    getDateFromFa() {
      return this.passTime();
    },
  },
  watch: {
    getDateFromFa: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    delImg(id) {
      const params = {
        ids: [id],
      };
      this.$axios
        .post(`/sys/schedule/del`, params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            // 当前页面删除完后就请求上一页面
            if (this.dayData.pageNum > 1 && this.dayData.list.length == 1) {
              this.pageChange(this.dayData.pageNum - 1);
            } else {
              // 刷新数据
              this.callBack(new Date(+this.passTime()));
            }
          }
        })
        .finally(() => {
          this.sche_detail_visible = false;
        });
    },
    delFile(id, index) {
      this.$axios.post("/api/v1/file/del", { id: id }).then((res) => {
        if (res.code == 200) {
          this.schedule_detail.fileInfoVoList.splice(index, 1);
        }
      });
    },
    download(url, name) {
      var $a = document.createElement("a");
      $a.setAttribute("href", url);
      $a.setAttribute("download", name);

      var evObj = document.createEvent("MouseEvents");
      evObj.initMouseEvent(
        "click",
        true,
        true,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        true,
        false,
        0,
        null
      );
      $a.dispatchEvent(evObj);
    },
    // 更多日程
    toMore(date) {
      this.type = 3;
      this.callBack(new Date(date));
    },
    fileFormatter(data) {
      //已上传附件的格式
      let file = {
        uid: data.id, // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
        name: data.fileName, // 文件名
        status: "done", // 状态有：uploading done error removed
        response: '{"status": "success"}', // 服务端响应内容
      };
      return file;
    },
    editImg(detail) {
      this.sche_detail_visible = false;
      this.editFormHandle(detail);
    },
    // 编辑日程
    editFormHandle({ id }) {
      // 获取日程详情
      this.$axios.get(`/sys/schedule/getInfo/${id}`).then((res) => {
        if (res.code == 200) {
          const data = res.data;
          this.schedule_form = { ...data };
          // 日期回显需要转成moment对象
          this.schedule_form.startTime = moment(data.startTime);
          this.schedule_form.endTime = moment(data.endTime);
          this.schedule_form.partInList = [];
          data.partInList.map((item) => {
            this.schedule_form.partInList.push(item.memberId);
          });
          this.schedule_form.syncList = [];
          data.syncList.map((item) => {
            this.schedule_form.syncList.push(item.memberId);
          });
          // 对上传的附件做回显
          this.schedule_form.fileList = [];
          data.fileInfoVoList.map((item) => {
            this.schedule_form.fileList.push(this.fileFormatter(item)); //已上传的附件
            let obj = {
              fileName: item.fileName,
              filePath: item.filePath,
              fileSize: item.fileSize,
              id: item.id,
            };
            this.schedule_file.push(obj); //提交时拿的字段，把已经上传的附件添加进去
          });
          this.editDateType = 2;
          this.title = "编辑日程";
          this.schedule_visible = true;
        }
      });
    },
    showModal() {
      this.editDateType = 1;
      this.title = "新建日程";
      this.schedule_visible = true;
    },
    dateChange(e, type) {
      const start = this.schedule_form.startTime;
      const end = this.schedule_form.endTime;
      if (start && end) {
        const startstr = moment(start).format("yyyy-MM-DD HH:mm:ss");
        const endstr = moment(end).format("yyyy-MM-DD HH:mm:ss");
        if (startstr >= endstr) {
          this.$message.error("日程开始时间必须小于结束时间");
          if (type == 1) {
            this.schedule_form.startTime = undefined;
          } else if (type == 2) {
            this.schedule_form.endTime = undefined;
          }
        }
      }
    },
    pageSizeChange(size) {
      this.dayData.pageNum = 1;
      this.dayData.pageSize = size;
      this.getList();
    },
    pageChange(page) {
      this.dayData.pageNum = page;
      this.getList();
    },
    onSearch() {
      this.dayData.pageNum = 1;
      this.getList();
    },
    getList() {
      let params = {};
      let url = "";
      console.log(this.type);
      if (this.type == 1) {
        // 月
        const year = this.getDateFromFa.getFullYear();
        const month = this.getDateFromFa.getMonth();
        url = "/sys/schedule/queryCalendarSchedule";
        params = {
          keyword: this.keyword,
          memberId: this.zjId ? this.zjId : null,
          start: +new Date(year, month, 1),
          end: +new Date(year, month + 1, 0, 23, 59, 59),
        };
      } else if (this.type == 2) {
        // 周
        url = "/sys/schedule/queryCalendarHourSchedule";
        params = {
          keyword: this.keyword,
          memberId: this.zjId ? this.zjId : null,
          start: +this.getMinMax.min,
          end: +this.getMinMax.max,
        };
      } else if (this.type == 3) {
        const y = this.getDateFromFa.getFullYear();
        const m = this.getDateFromFa.getMonth();
        const d = this.getDateFromFa.getDate();
        url = "/sys/schedule/pageList";
        params = {
          keyword: this.keyword,
          memberId: this.zjId ? this.zjId : null,
          start: +new Date(y, m, d),
          end: +new Date(y, m, d, 23, 59, 59),
          pageNum: this.dayData.pageNum,
          pageSize: this.dayData.pageSize,
        };
      }
      this.$axios.post(url, params).then((res) => {
        if (res.code == 200) {
          if (this.type == 1) {
            this.monthData = res.data;
          } else if (this.type == 2) {
            this.weekData = res.data;
          } else if (this.type == 3) {
            this.dayData = res.data;
          }
        }
      });
    },
    getMember() {
      this.$axios.post("/sys/member/listAll", {}).then((res) => {
        if (res.code == 200) {
          this.memberList = res.data;
          this.joinList = res.data;
        }
      });
    },
    // 获取场馆
    getHall() {
      this.$axios.post("/sys/authSelect/hallList", {}).then((res) => {
        if (res.code == 200) {
          this.hallList = res.data;
        }
      });
    },
    toDetail(id) {
      // 获取日程详情
      this.$axios.get(`/sys/schedule/getInfo/${id}`).then((res) => {
        if (res.code == 200) {
          this.schedule_detail = res.data;
          this.sche_detail_visible = true;
        }
      });
    },
    resetForm() {
      this.schedule_form = {
        scheduleName: undefined,
        startTime: undefined,
        endTime: undefined,
        sportsHallId: undefined,
        remark: undefined,
        syncList: [],
        partInList: [],
        fileList: [],
      };
      this.$refs.scheduleRule.resetFields();
    },
    handleChange(info) {
      if (info.file.status != undefined && info.file.status != "error") {
        try {
          this.schedule_file = [];
          info.fileList &&
            info.fileList.map((item) => {
              let obj = {
                fileName: item.response.data.fileName,
                filePath: item.response.data.url,
                fileSize: item.response.data.fileSize,
              };
              this.schedule_file.push(obj);
            });
          if (
            info.file.response &&
            info.file.response.code != 200 &&
            info.fileList.length <= 0
          ) {
            this.schedule_file = [];
          }
        } catch (e) {}
      }
    },
    // 新建日程
    addSchedule() {
      this.$refs.scheduleRule
        .validate(["scheduleName", "startTime", "endTime"])
        .then(() => {
          let param = {
            scheduleName: this.schedule_form.scheduleName,
            startTime: moment(this.schedule_form.startTime).valueOf(),
            endTime: moment(this.schedule_form.endTime).valueOf(),
            sportsHallId: this.schedule_form.sportsHallId
              ? this.schedule_form.sportsHallId
              : "",
            remark: this.schedule_form.remark ? this.schedule_form.remark : "",
            syncList: this.schedule_form.syncList.map((item) => ({
              memberId: item,
            })),
            partInList: this.schedule_form.partInList.map((item) => ({
              memberId: item,
            })),
            fileInfoSaveDTOS: this.schedule_file,
            type: 2,
          };
          if (this.editDateType == 1) {
            // 新建
            this.$axios.post("/sys/schedule/add", param).then((res) => {
              if (res.code == 200) {
                this.schedule_visible = false;
                // 清空表单
                this.resetForm();
                // 刷新数据
                this.callBack(new Date(+this.passTime()));
              }
            });
          } else if (this.editDateType == 2) {
            // 编辑
            param.id = this.schedule_form.id;
            this.$axios.post("/sys/schedule/edit", param).then((res) => {
              if (res.code == 200) {
                this.schedule_visible = false;
                // 清空表单
                this.resetForm();
                // 刷新数据
                this.callBack(new Date(+this.passTime()));
              }
            });
          }
        })
        .catch(() => {
          console.log("校验不通过");
        });
    },
    handleOk() {},
    clickToday() {
      this.callBack(new Date());
    },
    changeMonth(type) {
      // 切换月份
      let date = this.getDateFromFa;
      let val;
      if (this.type == 1) {
        if (type == "prev") {
          val = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        } else {
          val = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        }
      } else if (this.type == 2) {
        if (type == "prev") {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - 7
          );
        } else {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + 7
          );
        }
      } else if (this.type == 3) {
        if (type == "prev") {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - 1
          );
        } else {
          val = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() + 1
          );
        }
      }

      // 通知父级改变时间
      this.callBack(val);
    },
    changType(type) {
      if (this.type != type) {
        this.type = type;
        this.getList();
      }
    },
  },
  created() {
    this.getHall();
    this.getMember();
  },
};
</script>
<style lang='less' scoped>
.modal_content {
  height: 400px;
  overflow-y: scroll;
  color: var(--text-color);
  .modal_item {
    margin-bottom: 48px;
  }
  .header {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 21px;
  }
  .item_header {
    font-size: 16px;
  }
  .schedule_time_box {
    .schedule_time_item {
      width: 180px;
      padding: 15px 0 10px 0;
      margin-right: 32px;
      &:last-child {
        margin-right: 0;
      }
    }
    .schedule_date {
      font-size: 12px;
      margin: 5px 0;
    }
    .schedule_time {
      font-size: 25px;
      font-weight: 500;
    }
    .schedule_text {
      font-size: 12px;
      padding: 2px 10px;
      border-radius: 15px;
    }
  }
  .schedule_other {
    .other_title {
      margin-right: 24px;
    }
    .other_address {
      color: #bcbcbc;
    }
  }
  .join_member {
    .item_header {
      margin-bottom: 21px;
    }
    .avatar_box {
      width: 68px;
      height: 68px;
      border-radius: 50%;
      margin-bottom: 8px;
    }
  }
  .filelist_box {
    .item_header {
      margin-bottom: 21px;
    }
    .filelist_item {
      &:nth-of-type(2n-1) {

      }
      .opera_list {
        .down_btn {
          margin-right: 8px;
        }
      }
    }
  }
  .desc-label {
  }
}
.date-content {
  margin-left: 24px;
  user-select: none;
  min-height: 100%;
  box-sizing: border-box;
  .deep-bg {
  }
  .date-none {
    height: 100%;
    img {
      width: 81px;
    }
    p {
      margin-top: 31px;
      height: 27px;
      font-size: 20px;
      color: #bcbcbc;
    }
  }
  .date-select {
    width: 300px;
  }
  .add,
  .today {
    width: 100px;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
  }
  .add {
    background: #1890ff;
    margin-right: 16px;
  }
  .today {
    width: 80px;
    margin-left: 16px;
    border: 1px solid #1890ff;
  }
  .type {
    span {
      width: 54px;
      line-height: 41px;
      text-align: center;
      color: #bcbcbc;
      box-sizing: border-box;
      &:nth-of-type(1) {
        border-radius: 4px 0px 0px 4px;
      }
      &:nth-of-type(3) {
        border-radius: 0 4px 4px 0;
      }
      &.active {
        border-color: #1890ff;
        color: #1890ff;
      }
    }
  }
}
.head-title {
  transform: translateX(40px);
}
.icon-img {
  padding-right: 40px;
  img {
    width: 12px;
  }
}
.img-wrap {
  width: 180px;
  height: 115px;
  box-sizing: border-box;
}
.img1 {
  // background: url(@/assets/yf-img/green-bg.png) left top no-repeat;
  background-size: cover;
  margin-right: 32px;
}
.img2 {
  // background: url(@/assets/yf-img/orange-bg.png) left top no-repeat;
  background-size: cover;
}
.join-people {
  > section {
    margin-right: 44px;
  }
  img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }
}
.table {
  width: 100%;
  tr:nth-of-type(2n-1) {
  }
  tr {
    border-radius: 4px;
    padding: 0 16px;
  }
  td {
    height: 50px;
    vertical-align: middle;
    padding: 10px 16px;
    &:nth-of-type(1) {
      width: 25%;
    }
    &:nth-of-type(2) {
      width: 36%;
    }
    &:nth-of-type(3) {
      width: 20%;
    }
    &:nth-of-type(4) {
      width: 19%;
      white-space: nowrap;
    }
    .ant-btn-primary {
      color: #1890ff !important;
    }
    .ant-btn-dangerous {
      background: none !important;
    }
  }
}
</style>